import { CalloutComponentType } from "./callout-component-type.js";
const calloutComponentInputSelectableTypes = [
  CalloutComponentType.INPUT_SELECTABLE_RADIO,
  CalloutComponentType.INPUT_SELECTABLE_SELECTBOXES
];
export {
  calloutComponentInputSelectableTypes
};
